module.exports = __webpack_public_path__ + "static/media/sunhillassetspccltd.2dcfe10b.png";